module.exports = __webpack_public_path__ + "static/media/telephone.1830d6d6.png";